import { render, staticRenderFns } from "./fmMSCHistoryBillAddress.vue?vue&type=template&id=44410144&scoped=true&"
import script from "./fmMSCHistoryBillAddress.vue?vue&type=script&lang=js&"
export * from "./fmMSCHistoryBillAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44410144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44410144')) {
      api.createRecord('44410144', component.options)
    } else {
      api.reload('44410144', component.options)
    }
    module.hot.accept("./fmMSCHistoryBillAddress.vue?vue&type=template&id=44410144&scoped=true&", function () {
      api.rerender('44410144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/fmMSCHistoryBillAddress.vue"
export default component.exports